import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { FloatingSection } from '@uhg-abyss/web/ui/FloatingSection';
import React, { useRef } from 'react';

import { Navigation } from './components/Navigation';
import { SidebarSkeleton } from './components/Skeleton';

/**
 * Section: Sidebar
 *
 * @param currentAccessor
 * @param hasData
 * @param isFetching
 * @param isOpen
 * @param setCurrentTarget
 * @param toggleSidebar
 * @param widgets
 * @returns {Element}
 * @constructor
 */
export function Sidebar({
  currentAccessor = '',
  hasData = false,
  isFetching = false,
  isOpen = false,
  setCurrentTarget = () => {},
  toggleSidebar = () => {},
  widgets = [],
}) {
  const containerRef = useRef(null);

  return (
    <ErrorHandler location="src/layouts/Dashboard/sections/Sidebar/Sidebar.jsx">
      <div id="layout-dashboard-sidebar">
        {isFetching ? (
          <SidebarSkeleton />
        ) : (
          <React.Fragment>
            {hasData && (
              <div ref={containerRef} style={{ height: '100%' }}>
                <FloatingSection
                  alwaysFloat={false}
                  containerRef={containerRef}
                  css={{
                    'abyss-floating-section-root': {
                      '.abyss-drawer-menu-container': {
                        backgroundColor: 'var(--abyss-colors-gray1)',
                      },
                      boxShadow: 'none',
                    },
                  }}
                  position="top"
                  space={64}
                >
                  <Navigation
                    currentAccessor={currentAccessor}
                    isSidebarOpen={isOpen}
                    setCurrentTarget={setCurrentTarget}
                    toggleSidebar={toggleSidebar}
                    widgets={widgets}
                  />
                </FloatingSection>
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    </ErrorHandler>
  );
}
